import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function PricingCards() {
  const [selected, setSelected] = useState<'familiar'>('familiar');
  return <section id="pricing" className="py-16 px-4 md:px-8 bg-gradient-to-b from-orange-50 to-white" data-id="element-137">
      <div className="max-w-lg mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-139">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A1A1A] mb-2" data-id="element-140">
            Elegí tu <span className="text-[#F5A623]" data-id="element-141">pack</span>
          </h2>
          <p className="text-sm text-gray-500 text-center mb-8" data-id="element-142">
            La diferencia entre el básico y el familiar es solo $10.000. La
            diferencia en legado, infinita.
          </p>

          <div className="space-y-4 mb-8" data-id="element-143">
            {/* Pack Mamá */}
            <button onClick={() => setSelected('mama')} className={`w-full text-left rounded-xl p-5 transition-all border-2 ${selected === 'mama' ? 'border-[#F5A623] bg-orange-50 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-144">
              <div className="flex items-start gap-3" data-id="element-145">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === 'mama' ? 'border-[#F5A623]' : 'border-gray-300'}`} data-id="element-146">
                  {selected === 'mama' && <div className="w-3 h-3 rounded-full bg-[#F5A623]" data-id="element-147" />}
                </div>

                <div className="flex-1 min-w-0" data-id="element-148">
                  <div className="flex items-start justify-between gap-2" data-id="element-149">
                    <div data-id="element-150">
                      <p className="text-xs mb-1" data-id="element-151">📘</p>
                      <h3 className="font-bold text-[#1A1A1A] text-base leading-tight" data-id="element-152">
                        PACK MAMÁ
                      </h3>
                      <p className="text-xs text-gray-500 mt-0.5" data-id="element-153">
                        Solo Mamá + 4 Bonos
                      </p>
                      <p className="text-xs text-[#F5A623] font-semibold mt-1" data-id="element-154">
                        Acceso inmediato al email
                      </p>
                    </div>
                    <div className="text-right flex-shrink-0" data-id="element-155">
                      <p className="text-xs text-gray-400 line-through" data-id="element-156">
                        $81.000
                      </p>
                      <p className="text-2xl font-bold text-[#1A1A1A]" data-id="element-157">
                        $19.999
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </button>

            {/* Colección Familiar */}
            <button onClick={() => setSelected('familiar')} className={`w-full text-left rounded-xl p-5 pt-7 transition-all border-2 relative ${selected === 'familiar' ? 'border-[#F5A623] bg-orange-50 shadow-lg' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-158">
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#E8440A] text-white text-[10px] font-bold px-3 py-1 rounded-full shadow-md whitespace-nowrap" data-id="element-159">
                ⭐ EL MÁS ELEGIDO
              </span>
              <div className="flex items-start gap-3" data-id="element-160">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === 'familiar' ? 'border-[#F5A623]' : 'border-gray-300'}`} data-id="element-161">
                  {selected === 'familiar' && <div className="w-3 h-3 rounded-full bg-[#F5A623]" data-id="element-162" />}
                </div>

                <div className="flex-1 min-w-0" data-id="element-163">
                  <div className="flex items-start justify-between gap-2" data-id="element-164">
                    <div data-id="element-165">
                      <p className="text-xs mb-1" data-id="element-166">🏆</p>
                      <h3 className="font-bold text-[#1A1A1A] text-base leading-tight" data-id="element-167">
                        COLECCIÓN FAMILIAR
                      </h3>
                      <p className="text-xs text-gray-500 mt-0.5" data-id="element-168">
                        Pack Mamá + Colección Familiar
                      </p>
                      <ul className="mt-2 space-y-1 text-xs text-gray-700" data-id="element-169">
                        <li className="flex items-start gap-1.5" data-id="element-170">
                          <span className="text-[#2E7D32]" data-id="element-171">✓</span>
                          <span data-id="element-172">Papá, Cuéntame Tu Historia</span>
                        </li>
                        <li className="flex items-start gap-1.5" data-id="element-173">
                          <span className="text-[#2E7D32]" data-id="element-174">✓</span>
                          <span data-id="element-175">Abuela, Cuéntame Tu Historia</span>
                        </li>
                        <li className="flex items-start gap-1.5" data-id="element-176">
                          <span className="text-[#2E7D32]" data-id="element-177">✓</span>
                          <span data-id="element-178">Abuelo, Cuéntame Tu Historia</span>
                        </li>
                      </ul>
                      <p className="text-xs text-[#F5A623] font-semibold mt-2" data-id="element-179">
                        Ahorrás más de $47.000
                      </p>
                    </div>
                    <div className="text-right flex-shrink-0" data-id="element-180">
                      <p className="text-xs text-gray-400 line-through" data-id="element-181">
                        $120.000
                      </p>
                      <p className="text-2xl font-bold text-[#F5A623]" data-id="element-182">
                        $29.999
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </div>

          <motion.button whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          const url = selected === 'familiar' ? 'https://pagos.indigo33.shop/cart/44066086027352:1' : 'https://pagos.indigo33.shop/cart/44066085601368:1';
          window.open(url, '_blank');
        }} className="w-full bg-[#F5A623] text-white py-4 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all cursor-pointer" data-id="element-183">
            {selected === 'familiar' ? '💝 QUIERO LA COLECCIÓN COMPLETA →' : '💛 QUIERO EL PACK MAMÁ →'}
          </motion.button>

          <p className="text-center text-[10px] text-gray-400 mt-3" data-id="element-184">
            🔒 Pago 100% seguro · 📥 Acceso inmediato · ↩️ Garantía 14 días
          </p>
        </motion.div>
      </div>
    </section>;
}